/*
 *
 * ChooseFileDialog
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 15-May-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import { IonAlert } from '@ionic/react'
import { useIntl } from 'react-intl'

const ChooseFileDialog = (props) => {
  const intl = useIntl()

  return (
    <IonAlert
      isOpen
      onDidDismiss={() => props.actions.doHidePopup()}
      header={intl.formatMessage({ id: 't.app.components.dropzone.insertDocuments' })}
      message=''
      buttons={[
        {
          text: intl.formatMessage({ id: 't.app.components.dropzone.addphoto' }),
          role: 'confirm',
          handler: () => {
            props.data.chooseGallery()
            props.actions.doHidePopup()
          }
        },
        {
          text: intl.formatMessage({ id: 't.app.components.dropzone.adddocument' }),
          role: 'confirm',
          handler: () => {
            props.data.chooseDocuments()
            props.actions.doHidePopup()
          }
        },
        { text: intl.formatMessage({ id: 't.app.cancel' }), role: 'cancel', handler: () => props.actions.doHidePopup() }
      ]}
    />
  )
}

ChooseFileDialog.propTypes = {
  actions: PropTypes.object,
  data: PropTypes.object
}

ChooseFileDialog.defaultProps = {
  actions: {},
  data: {}
}

export default ChooseFileDialog
